export default __webpack_public_path__ + "static/media/error1img.2489b586.png";